import React from 'react';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { PivotLinkSize, PivotLinkFormat, PivotItem, Pivot } from 'office-ui-fabric-react/lib/Pivot';
import Cookies from "universal-cookie";

import Header from '../component/Header';
import Types from './settings/Types';
import Companies from './settings/Companies';
import Smtp from './settings/Smtp';
import General from './settings/General';

export default class Settings extends React.Component {
  constructor( props ) {
    super( props );

    let cookies = new Cookies();
    let session = cookies.get( 'session' );

    if( !session ) {
      window.location.href = '/auth';
    }
  }
  render() {
    return (
      <Fabric>
        <Header title="Ajustes y configuración" />
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg12">
              <Pivot linkFormat={PivotLinkFormat.links} linkSize={PivotLinkSize.normal}>
                <PivotItem linkText="Configuración general">
                  <General />
                </PivotItem>
                <PivotItem linkText="Tipos de pólizas">
                  <Types />
                </PivotItem>
                <PivotItem linkText="Empresas aseguradoras">
                  <Companies />
                </PivotItem>
                <PivotItem linkText="Servidor de correo">
                  <Smtp />
                </PivotItem>
              </Pivot>
            </div>
          </div>
        </div>
      </Fabric>
    );
  }
}


// WEBPACK FOOTER //
// ./src/screen/Settings.jsx